<app-loading-spinner [active]="exporting"
    [customMessage]="exporting ? 'Gerando Relatório. Não feche esta janela...' : ''"
    [persistentMessage]="exporting"
    [showContinueButton]="exporting"></app-loading-spinner>
<div class="row">
    <div class="col-12">
        <div class="dash-details-card card-padding-top">
            <ng-container *ngIf="loading">
                <div class="dash-details-card-body">
                    <div class="row">
                        <div class="col-4 d-flex flex-column">
                            <ngx-skeleton-loader [theme]="{
                                height: '41px',
                                margin:'0'
                              }">
                            </ngx-skeleton-loader>
                        </div>
                        <div class="col-4 d-flex flex-column">
                            <ngx-skeleton-loader [theme]="{
                                height: '41px',
                                margin:'0'
                              }">
                            </ngx-skeleton-loader>
                        </div>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>

                    <div class="row">
                        <div class="col-2 d-flex flex-column">
                            <ngx-skeleton-loader [theme]="{
                                height: '41px',
                                margin:'0'
                              }">
                            </ngx-skeleton-loader>
                        </div>
                        <div class="col-2 d-flex flex-column">
                            <ngx-skeleton-loader [theme]="{
                                height: '41px',
                                margin:'0'
                              }">
                            </ngx-skeleton-loader>
                        </div>
                        <div class="col-2 d-flex flex-column">
                            <ngx-skeleton-loader [theme]="{
                                height: '41px',
                                margin:'0'
                              }">
                            </ngx-skeleton-loader>
                        </div>
                        <div class="col-3 d-flex flex-column">
                            <ngx-skeleton-loader [theme]="{
                                height: '41px',
                                margin:'0'
                              }">
                            </ngx-skeleton-loader>
                        </div>
                        <div class="col-2 d-flex flex-column">
                            <ngx-skeleton-loader [theme]="{
                                height: '41px',
                                margin:'0'
                              }">
                            </ngx-skeleton-loader>
                        </div>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>

                    <div class="row">
                        <div class="col-2 d-flex flex-column">
                            <ngx-skeleton-loader [theme]="{
                                height: '41px',
                                margin:'0'
                              }">
                            </ngx-skeleton-loader>
                        </div>
                        <div class="col-2 d-flex flex-column">
                            <ngx-skeleton-loader [theme]="{
                                height: '41px',
                                margin:'0'
                              }">
                            </ngx-skeleton-loader>
                        </div>
                        <div class="col-2 d-flex flex-column">
                            <ngx-skeleton-loader [theme]="{
                                height: '41px',
                                margin:'0'
                              }">
                            </ngx-skeleton-loader>
                        </div>
                        <div class="col-2 d-flex flex-column">
                            <ngx-skeleton-loader [theme]="{
                                height: '41px',
                                margin:'0'
                              }">
                            </ngx-skeleton-loader>
                        </div>
                        <div class="col-2 d-flex flex-column">
                            <ngx-skeleton-loader [theme]="{
                                height: '41px',
                                margin:'0'
                              }">
                            </ngx-skeleton-loader>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="!loading">
                <div class="shareholder-toolbar">
                    <div class="row no-gutters w-100">
                        <div
                            class="col-12 d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <button type="button" class="sort-button mr-2"
                                    (click)="refreshData()"
                                    [disabled]="loading">
                                    <svg-icon
                                        src="assets/images/icon-renew.svg"></svg-icon>
                                    <span>Atualizar</span>
                                </button>
                            </div>
                            <div class="d-flex align-items-center">
                                <app-button-with-dropdown label="Baixar tabela"
                                    iconSrc="assets/images/icon_download.svg"
                                    [showOptions]="showExportOptions"
                                    (toggleShowOptions)="toggleExportOptions()"
                                    (onClick)="toggleExportOptions()"
                                    [outline]="true" class="export-button mr-3"
                                    [disabled]="loading || exporting || !data?.length">
                                    <button class="dropdown-item"
                                        (click)="downloadTable('csv')">Baixar
                                        como CSV</button>
                                    <button class="dropdown-item"
                                        (click)="downloadTable('pdf')">Baixar
                                        como PDF</button>
                                    <button class="dropdown-item"
                                        (click)="downloadTable('xlsx')">Baixar
                                        como XLSX</button>
                                </app-button-with-dropdown>
                                <app-button *ngIf="hasFilters && !loading"
                                    [danger]="true" [outline]="true"
                                    (onClick)="resetFilters()"
                                    class="add-button mr-2">
                                    <svg-icon src="assets/images/icon-times.svg"
                                        class="filter-clear-icon"></svg-icon>
                                    Limpar filtros
                                </app-button>
                                <app-button [inverted]="true" class="add-button"
                                    (onClick)="toggleFilterModal()"
                                    [disabled]="loading">
                                    <svg-icon
                                        src="assets/images/icon_filter.svg"
                                        class="mr-2">
                                    </svg-icon>
                                    {{ hasFilters ? 'Editar filtros' : 'Filtrar
                                    listagem' }}
                                </app-button>
                            </div>
                        </div>
                        <div class="col-12 mt-3"
                            *ngIf="!loading && hasFilters && appliedFilters.length > 0">
                            <div
                                class="d-flex flex-wrap align-items-center justify-content-end">
                                <app-filter-tag
                                    *ngFor="let filter of appliedFilters"
                                    [label]="filter.label"
                                    [value]="filter.value">
                                </app-filter-tag>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list-container mt-3 shareholder-table-native"
                    *ngIf="data?.length">
                    <div class="table-details-container">
                        <ul class="app-table-details"
                            [ngStyle]="shareholderTableGridStyle">
                            <li class="app-table-details-header">Cotistas</li>
                            <li class="app-table-details-header">Status</li>
                            <li class="app-table-details-header shareholder-col-profile">Perfil/Validade
                            </li>
                            <li *ngIf="canView" class="app-table-details-header">
                            </li>
                        </ul>
                        <ul *ngFor="let row of data"
                            class="app-table-details-body"
                            [ngStyle]="shareholderTableGridStyle">
                            <li class="app-table-details-body-row">
                                <div class="dash-card-item p-0">
                                    <div
                                        class="dash-card-item-initials mr-3">
                                        <span>{{
                                            getInitials(row?.links?.register)
                                            }}</span>
                                    </div>
                                    <div class="dash-card-item-content">
                                        <div
                                            class="dash-card-item-content-title">
                                            {{
                                            row?.links?.register?.type ===
                                            'PF'
                                            ? row?.links?.register?.person?.full_name
                                            : (row?.links?.register?.company?.corporate_name
                                            || '-') }}
                                        </div>
                                        <div
                                            class="dash-card-item-content-subtitle">
                                            {{
                                            row?.links?.register
                                            ? formatDocument(row.links.register)
                                            : '' }}
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="app-table-details-body-row">
                                <span class="status-badge"
                                    [ngClass]="getShareholderStatusBadgeClass(row)">{{
                                    getShareholderStatusLabel(row) }}</span>
                            </li>
                            <li
                                class="app-table-details-body-row shareholder-col-profile">
                                <ng-container
                                    *ngIf="getShareholderInvestorProfileData(row) as ip; else noInvestorProfile">
                                    <div *ngIf="ip.not_declared || ip.profile === null"
                                        class="d-flex flex-column profile-validity-cell">
                                        <div
                                            class="profile-badge profile-badge-not-declared">
                                            Não declarado</div>
                                    </div>
                                    <ng-container
                                        *ngIf="!ip.not_declared && ip.profile != null">
                                        <ng-container
                                            *ngIf="getShareholderProfileConfig(ip.profile) as cfg; else profFallback">
                                            <div
                                                class="d-flex flex-column profile-validity-cell">
                                                <div class="profile-badge"
                                                    [ngClass]="cfg.badgeClass">{{
                                                    cfg.type }}</div>
                                                <span
                                                    *ngIf="getShareholderExpirationText(row)"
                                                    class="profile-expiration-text"
                                                    [class.text-danger]="ip.expired || (ip.days_until_expiration ?? 0) < 0">
                                                    {{
                                                    getShareholderExpirationText(row)
                                                    }}</span>
                                            </div>
                                        </ng-container>
                                        <ng-template #profFallback>-</ng-template>
                                    </ng-container>
                                </ng-container>
                                <ng-template #noInvestorProfile>
                                    <div class="dash-card-item-content">
                                        <div
                                            class="dash-card-item-content-title">
                                            -</div>
                                    </div>
                                </ng-template>
                            </li>
                            <li *ngIf="canView"
                                class="app-table-details-body-row">
                                <div
                                    class="d-flex align-items-center icon-container">
                                    <div class="shareholder-visualizer"
                                        [class.shareholder-visualizer-disabled]="row?.links?.register?.approval_status === 'em_edicao'"
                                        role="button"
                                        [attr.tabindex]="row?.links?.register?.approval_status === 'em_edicao' ? -1 : 0"
                                        [attr.aria-disabled]="row?.links?.register?.approval_status === 'em_edicao'"
                                        [attr.title]="row?.links?.register?.approval_status === 'em_edicao' ? 'Indisponível para registros em edição' : 'Visualizar'"
                                        (click)="onShareholderViewClick(row)">
                                        <svg-icon
                                            src="assets/images/icon-eye.svg"></svg-icon>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <app-empty-content [isVisible]="!data?.length"
                    title="Nenhum cotista encontrado"
                    description="Não foi encontrado nenhum cotista nesse cadastro"
                    icon="/assets/images/forgot-password-icon2.png">
                </app-empty-content>
            </ng-container>
        </div>
        <app-spacer [bottom]="24"></app-spacer>
    </div>
</div>

<app-side-filter-modal [active]="showFilterModal" [formGroup]="filterForm"
    [loading]="loading" title="Filtrar listagem"
    [disableApplyButton]="!canApplyFilters" [closeOnApply]="false"
    (onClose)="toggleFilterModal()" (onApply)="applyFilters()"
    (onReset)="resetFilters()">
    <div class="row">
        <div class="col-12">
            <app-input [group]="filterForm" controlName="name"
                label="Nome / Razão Social" placeholder="Digite">
            </app-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
        <div class="col-12">
            <app-masked-input [group]="filterForm" controlName="document"
                label="CPF / CNPJ" documentType="cpfOrCnpj" placeholder="Digite">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
        <div class="col-12">
            <span class="filter-section-label">Status dos cotistas</span>
            <div class="filter-checkbox-group">
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="statusHomologado">
                    <span>Homologado</span>
                </label>
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="statusEmAprovacao">
                    <span>Em aprovação</span>
                </label>
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="statusRejeitado">
                    <span>Rejeitado</span>
                </label>
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="statusEmEdicao">
                    <span>Em edição</span>
                </label>
            </div>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
        <div class="col-12">
            <span class="filter-section-label">Perfil dos cotistas</span>
            <div class="filter-checkbox-group">
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="profileConservador">
                    <span>Conservador</span>
                </label>
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="profileModerado">
                    <span>Moderado</span>
                </label>
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="profileAgressivo">
                    <span>Agressivo</span>
                </label>
            </div>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
        <div class="col-12 filter-export-section">
            <span class="filter-section-label">Informações adicionais na
                exportação</span>
            <p class="filter-export-description">
                As informações selecionadas abaixo serão incluídas apenas nos
                arquivos exportados (CSV/PDF), sem afetar a visualização da
                tabela.
            </p>
            <div class="filter-checkbox-group">
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="exportIncludeEmail">
                    <span>E-mail</span>
                </label>
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="exportIncludePhone">
                    <span>Telefone</span>
                </label>
            </div>
        </div>
    </div>
</app-side-filter-modal>